// @flow

import { useRef, useState, useEffect } from 'react';
import { useAppValue } from '@tectonics/app-values';
import { useUserInputValue } from '@tectonics/prs/user-input-values';
import { VALID } from '@tectonics/prs/validation';
import { searchBrazilianZipcode } from '@tectonics/prs/brazil/cep-search';
import { validateBrazilianZipcode  } from '@tectonics/prs/brazil/validation';

export function useSearchZipcodeDynamically(): [bool, bool] {
  const [zipcodeValue] = useUserInputValue('brazilianZipcode');

  const lastSearchedZipcodeValue = useRef<?string>(zipcodeValue);
  const [hasBeenSearchedBefore, setHasBeenSearchedBefore] = useState<bool>(validateBrazilianZipcode(zipcodeValue) === VALID);
  const [isSearching, setIsSearching] = useState<bool>(false);

  const [, setBrazilianState] = useUserInputValue('brazilianState');
  const [, setBrazilianCity] = useUserInputValue('brazilianCity');
  const [, setBrazilianAddress] = useUserInputValue('brazilianAddress');

  const [, setAbwAlertsBlocked] = useAppValue('abwAlertsBlock');

  useEffect(() => {
    (async () => {
      if (validateBrazilianZipcode(zipcodeValue) === VALID && zipcodeValue !== lastSearchedZipcodeValue.current) {
        lastSearchedZipcodeValue.current = zipcodeValue;

        setAbwAlertsBlocked(true);
        setIsSearching(true);
        const result = await searchBrazilianZipcode(zipcodeValue);
        if (result.zipcode === lastSearchedZipcodeValue.current) {
          setAbwAlertsBlocked(false);
          setIsSearching(false);
          setHasBeenSearchedBefore(true);
          setBrazilianState(result.state);
          setBrazilianCity(result.city);
          setBrazilianAddress(result.street_name);
        }
      }
    })();
  }, [zipcodeValue, setBrazilianState, setBrazilianAddress, setBrazilianCity]);

  return [isSearching, hasBeenSearchedBefore];
}
